import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useAuth } from '@/composables/useAuth'
import { toast } from '@/components/ui/toast/use-toast'

export function useAvatarCheck() {
  const router = useRouter()
  const userStore = useUserStore()
  const { isGuide } = useAuth()

  function checkAvatarOrRedirect(): boolean {
    if (!isGuide.value && !userStore.currentUser?.avatar_image) {
      toast({
        title: 'Profile Picture Required',
        description: 'A profile picture is required to continue the program',
        variant: 'destructive',
        duration: 5000,
      })
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      router.push('/account?no_profile_picture=true')
      return false
    }
    return true
  }

  return { checkAvatarOrRedirect }
}
